<template lang="pug">
payment-order-block-form( ref="depositForm" )
  app-select( v-model="form.courtCard" label="Выберите суд" hideDetails dense :items="sortedCourts" item-text="title" item-value="id" :menu-props="menuProps" @input="handleInputForm" :rules="[rules.required]" )
  app-select( v-model="form.personaType" label="Вид плательщика" hideDetails dense :items="personaTypeList" item-text="title" item-value="value" :menu-props="menuProps" @input="handleSelectPersonaType" :rules="[rules.number]" )
  app-text-field( v-model="form.courtCase" label="Номер дела" hideDetails dense @input="handleInputForm" :rules="[rules.required]" )
  app-select( v-model="form.caseType" label="Тип дела" hideDetails dense :items="caseTypeList" item-text="title" item-value="value" :menu-props="menuProps" @input="handleInputForm" :rules="[rules.number]" )
  app-text-field( v-model="form.summa" label="Сумма депозита в рублях" hideDetails dense :rules="[rules.required]" type="number"  @input="handleInputForm" @change="handleChange" )
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import PaymentOrderBlockForm from './PaymentOrderBlockForm.vue';
import { PersonaType, CaseType } from '../../../models/payment.order.form.models';
import { $_validate_rules } from '@/common/ValidateRules'
import { mapGetters } from 'vuex/dist/vuex.common.js';
export default {
  mixins: [ $_validate_rules ],
  components: {
    PaymentOrderBlockForm
  },

  props: {
    form: null
  },

  data() {
    return {
      menuProps: {
        bottom: true, offsetY: true, light: true
      }
    }
  },

  computed: {
    ...mapState('expert', ['region', 'personaType']),
    ...mapGetters('expert', ['sortedCourts']),

    personaTypeList() {
      return Object.values(PersonaType)
    },

    caseTypeList() {
      return Object.values(CaseType)
    },

    hasErrors() {
      return this.$refs.depositForm.$refs.blockForm.validate()
    }, 
  }, 

  methods: {
    ...mapMutations('expert', ['setPersonaType']),

    handleSelectPersonaType(value) {
      this.$emit('cleanForm')
      this.setPersonaType(value)
    },

    handleInputForm() {
      this.$emit('formChanged', { price: !this.hasErrors })
    },

    handleChange() {
      this.$emit('handleSummInput', this.form.summa)
    }
  }
}
</script>
